import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { installTranslationCrashGuard } from './utils/translationCrashGuard';
import './styles/global.css';

// Must run BEFORE the first render: it patches the DOM methods React commits through, and a
// tree already mounted would keep the unpatched ones. See the module header — a page
// translator reparents our text nodes and React then crashes removing them.
installTranslationCrashGuard();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
